<template>
  <h2 class="title">
    <template v-if="anchor">
      <a :id="anchor" />
      <a :href="'#' + anchor" v-html="title" />
    </template>
    <span v-else v-html="title" />
  </h2>
</template>

<style scoped>
.title > a {
  text-decoration: none;
  color: unset;
}
</style>

<script>
// Note: you could use something like the following to convert a title into a legible URL-safe anchor, but I feel like
// titles are subject to change, and once an anchor is published, it should never change. Splitting up the parameters
// forces you to think twice and make sure you have a reliable anchor.
// title.replace(/[^A-Za-z0-9 -]/g, '').toLowerCase().replace(/ /g, '_')

export default {
  name: 'faq-header',
  props: [ 'title', 'anchor' ]
}
</script>
